/* Prophecy Shop the Kit (v2): category tabs, sticky bar, quick add, quick-buy sheet */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  const lang = document.documentElement.lang || 'en-GB';
  const money = (cents) => { try { return new Intl.NumberFormat(lang.includes('-') ? lang : lang + '-GB', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } };
  const ICON_X = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const ICON_TICK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M2 6h12v10H2zM14 10h4.5l3 3v3H14"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';

  async function addToCart(id, qty) {
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: qty }], sections: 'cart-icon-bubble', sections_url: location.pathname }) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section') || doc.body;
      bubble.innerHTML = inner.innerHTML;
      bubble.classList.remove('pk-bump'); void bubble.offsetWidth; bubble.classList.add('pk-bump');
    }
    document.dispatchEvent(new CustomEvent('prophecy:cart-added', { detail: data }));
    return data;
  }

  /* ---------- quick-buy sheet (one per page) ---------- */
  let sheet, S = {};
  function buildSheet(el) {
    if (sheet) return sheet;
    const t = el.dataset;
    sheet = document.createElement('div');
    sheet.className = 'pk-sheet';
    sheet.style.setProperty('--pk-font', getComputedStyle(el).getPropertyValue('--pk-font'));
    sheet.innerHTML = `
      <div class="pk-scrim" data-close></div>
      <div class="pk-panel-sheet" role="dialog" aria-modal="true" aria-labelledby="pk-sheet-title" tabindex="-1">
        <span class="pk-sheet-grab" aria-hidden="true"></span>
        <div class="pk-sheet-top"><span>${t.qbTitle || 'Quick buy'}</span><button type="button" class="pk-x" data-close aria-label="${t.close || 'Close'}">${ICON_X}</button></div>
        <div class="pk-sheet-body">
          <div class="pk-sheet-prod"><img alt="" width="96" height="120"><div><h3 class="pk-sheet-title" id="pk-sheet-title"></h3><p class="pk-sheet-price"></p></div></div>
          <div class="pk-choose"></div>
          <div class="pk-add-row">
            <div class="pk-qty"><span>${t.qty || 'Quantity'}</span><div class="pk-step"><button type="button" data-q="-1" aria-label="-">&minus;</button><output aria-live="polite">1</output><button type="button" data-q="1" aria-label="+">+</button></div></div>
            ${t.note ? `<p class="pk-sheet-note">${ICON_TRUCK}<span></span></p>` : ''}
            <p class="pk-sheet-msg" role="alert"></p>
          </div>
          <div class="pk-done" aria-live="polite">
            <div class="pk-done-tick">${ICON_TICK}</div>
            <h3>${t.doneTitle || 'Added to your cart'}</h3><p class="pk-done-sub"></p>
            <div class="pk-done-actions"><a class="pk-btn" href="${root}cart">${t.viewCart || 'View cart & checkout'}</a><button type="button" class="pk-btn pk-btn--ghost" data-close>${t.keep || 'Keep shopping'}</button></div>
          </div>
        </div>
        <div class="pk-sheet-foot pk-add-row"><button type="button" class="pk-btn pk-sheet-add"><span>${t.add || 'Add to cart'}</span></button><a class="pk-sheet-link" href="#">${t.details || 'View full details'}</a></div>
      </div>`;
    if (t.note) sheet.querySelector('.pk-sheet-note span').textContent = t.note;
    document.body.appendChild(sheet);
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) closeSheet(); });
    sheet.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSheet();
      if (e.key === 'Tab') { // focus trap
        const f = [...sheet.querySelectorAll('button, a[href], input:not([disabled])')].filter((x) => x.offsetParent !== null);
        if (!f.length) return; const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    sheet.querySelectorAll('[data-q]').forEach((b) => b.addEventListener('click', () => { S.qty = Math.max(1, Math.min(20, S.qty + +b.dataset.q)); sheet.querySelector('.pk-step output').textContent = S.qty; if (S.product) pickVariant(); }));
    sheet.querySelector('.pk-sheet-add').addEventListener('click', async () => {
      const v = S.variant; const btn = sheet.querySelector('.pk-sheet-add'); const msg = sheet.querySelector('.pk-sheet-msg');
      if (!v || !v.available) return;
      btn.classList.add('is-loading'); msg.textContent = '';
      try {
        await addToCart(v.id, S.qty);
        sheet.querySelector('.pk-done-sub').textContent = `${S.qty} × ${S.product.title}${v.title && v.title !== 'Default Title' ? ' — ' + v.title : ''}`;
        sheet.classList.add('is-done');
        sheet.querySelector('.pk-done .pk-btn').focus();
      } catch (err) { msg.textContent = err.message; }
      btn.classList.remove('is-loading');
    });
    // swipe down to close (mobile)
    const panel = sheet.querySelector('.pk-panel-sheet'); let sy = null, dy = 0;
    panel.addEventListener('touchstart', (e) => { const body = sheet.querySelector('.pk-sheet-body'); if (body.scrollTop > 0 && !e.target.closest('.pk-sheet-top, .pk-sheet-grab')) return; sy = e.touches[0].clientY; dy = 0; }, { passive: true });
    panel.addEventListener('touchmove', (e) => { if (sy === null) return; dy = Math.max(0, e.touches[0].clientY - sy); if (dy > 0) { panel.style.transition = 'none'; panel.style.transform = `translateY(${dy}px)`; } }, { passive: true });
    panel.addEventListener('touchend', () => { if (sy === null) return; panel.style.transition = ''; panel.style.transform = ''; if (dy > 110) closeSheet(); sy = null; });
    return sheet;
  }
  function pickVariant() {
    const p = S.product; const sel = S.sel;
    S.variant = p.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null;
    const v = S.variant; const btn = sheet.querySelector('.pk-sheet-add'); const t = S.el.dataset;
    const price = v ? v.price : p.price;
    const cmp = v ? v.compare_at_price : p.compare_at_price;
    sheet.querySelector('.pk-sheet-price').innerHTML = `${money(price)}${cmp && cmp > price ? `<s>${money(cmp)}</s>` : ''}`;
    const label = btn.querySelector('span');
    if (!v) { btn.disabled = true; label.textContent = t.unavailable || 'Unavailable'; }
    else if (!v.available) { btn.disabled = true; label.textContent = t.soldOut || 'Sold out'; }
    else { btn.disabled = false; label.textContent = `${t.add || 'Add to cart'} · ${money(price * S.qty)}`; }
    // mark unavailable values given other selections
    p.options.forEach((name, i) => {
      sheet.querySelectorAll(`input[data-i="${i}"]`).forEach((inp) => {
        const ok = p.variants.some((x) => x.available && x.options[i] === inp.value && x.options.every((o, j) => j === i || o === sel[j]));
        inp.classList.toggle('is-na', !ok);
      });
      const lg = sheet.querySelector(`legend[data-i="${i}"] b`); if (lg) lg.textContent = sel[i];
    });
    if (v && v.featured_image) sheet.querySelector('.pk-sheet-prod img').src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=240';
  }
  let lastFocus = null;
  async function openSheet(el, handle, opener) {
    buildSheet(el); S = { el, qty: 1, sel: [], product: null, variant: null };
    lastFocus = opener || document.activeElement;
    sheet.classList.remove('is-done');
    sheet.querySelector('.pk-step output').textContent = '1';
    sheet.querySelector('.pk-sheet-msg').textContent = '';
    const choose = sheet.querySelector('.pk-choose');
    choose.innerHTML = '<div class="pk-skel"></div><div class="pk-skel"></div>';
    const card = opener && opener.closest('.pk-card');
    const img = card && card.querySelector('.pk-media img');
    sheet.querySelector('.pk-sheet-prod img').src = img ? (img.currentSrc || img.src) : '';
    sheet.querySelector('.pk-sheet-title').textContent = card ? card.querySelector('h4').textContent.trim() : '';
    sheet.querySelector('.pk-sheet-price').textContent = card ? card.querySelector('.pk-price').textContent.trim() : '';
    sheet.querySelector('.pk-sheet-link').href = root + 'products/' + handle;
    sheet.querySelector('.pk-sheet-add').disabled = true;
    sheet.classList.add('is-open'); document.documentElement.classList.add('pk-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-on')));
    setTimeout(() => sheet.querySelector('.pk-x').focus(), 60);
    try {
      const p = await (await fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })).json();
      S.product = p;
      const first = p.variants.find((v) => v.available) || p.variants[0];
      S.sel = [...first.options];
      choose.innerHTML = '';
      p.options.forEach((opt, i) => {
        const name = typeof opt === 'string' ? opt : opt.name;
        const values = typeof opt === 'string' ? [...new Set(p.variants.map((v) => v.options[i]))] : opt.values;
        if (p.variants.length === 1 && values.length === 1 && values[0] === 'Default Title') return;
        const fs = document.createElement('fieldset'); fs.className = 'pk-opt';
        const lg = document.createElement('legend'); lg.dataset.i = i; lg.textContent = name + ':'; lg.appendChild(document.createElement('b'));
        fs.appendChild(lg);
        const wrap = document.createElement('div'); wrap.className = 'pk-pills';
        values.forEach((val, k) => {
          const id = `pk-o-${i}-${k}`;
          const d = document.createElement('div'); d.className = 'pk-pill';
          const inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'pk-o-' + i; inp.id = id; inp.value = val; inp.dataset.i = i; inp.checked = val === S.sel[i];
          const lb = document.createElement('label'); lb.htmlFor = id; lb.textContent = val;
          inp.addEventListener('change', () => { S.sel[i] = val; pickVariant(); });
          d.append(inp, lb); wrap.appendChild(d);
        });
        fs.appendChild(wrap); choose.appendChild(fs);
      });
      pickVariant();
    } catch (err) {
      choose.innerHTML = ''; sheet.querySelector('.pk-sheet-msg').textContent = el.dataset.loadError || 'Could not load options. Please view the product page.';
    }
  }
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-on'); document.documentElement.classList.remove('pk-lock');
    setTimeout(() => sheet.classList.remove('is-open'), reduce ? 0 : 450);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- section ---------- */
  function stickyOffset() {
    // anything fixed/sticky pinned to the top of the viewport (theme header, announcement or free-shipping bars)
    let top = 0; const seen = new Set();
    [0.15, 0.5, 0.85].forEach((fx) => {
      document.elementsFromPoint(window.innerWidth * fx, 2).forEach((n) => {
        for (let x = n; x && x !== document.body && x !== document.documentElement; x = x.parentElement) {
          if (seen.has(x)) break; seen.add(x);
          if (x.closest('.pk-bar, .pk-sheet')) break;
          const cs = getComputedStyle(x);
          if (cs.position === 'fixed' || cs.position === 'sticky') {
            const r = x.getBoundingClientRect();
            if (r.top <= 2 && r.height > 0 && r.height < 240 && cs.visibility !== 'hidden' && +cs.opacity !== 0) top = Math.max(top, r.bottom);
            break;
          }
        }
      });
    });
    return Math.max(0, Math.round(top));
  }
  function init(el) {
    if (el.dataset.pkReady) return; el.dataset.pkReady = '1';
    const tabs = [...el.querySelectorAll('.pk-cat')];
    const panels = [...el.querySelectorAll('.pk-panel')];
    const bar = el.querySelector('.pk-bar'); const cats = el.querySelector('.pk-cats');
    function select(i, opts = {}) {
      tabs.forEach((t, j) => { const on = j === i; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach((p, j) => { const on = j === i; p.hidden = !on; p.classList.remove('is-in'); if (on && !reduce) { void p.offsetWidth; p.classList.add('is-in'); } });
      if (opts.focus) tabs[i].focus({ preventScroll: true });
      const t = tabs[i];
      if (cats.scrollWidth > cats.clientWidth) cats.scrollTo({ left: t.offsetLeft - (cats.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      if (opts.user && bar.classList.contains('is-stuck')) { // keep the new category's first row in view
        const y = el.querySelector('.pk-panel:not([hidden])').getBoundingClientRect().top + scrollY - bar.offsetHeight - stickyOffset() - 8;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i, { user: true }));
      t.addEventListener('keydown', (e) => {
        let n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0; if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, { focus: true }); }
      });
    });
    // sticky bar state + offset under the theme's sticky header
    let ticking = false;
    const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => {
      ticking = false; const off = stickyOffset(); el.style.setProperty('--pk-top', off + 'px');
      const r = bar.getBoundingClientRect(); const sr = el.getBoundingClientRect();
      bar.classList.toggle('is-stuck', r.top <= off + 1 && sr.top < off - 10 && sr.bottom > r.height + off + 60);
    }); };
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); onScroll();

    el.addEventListener('click', (e) => {
      const qb = e.target.closest('[data-pk-quick]'); if (!qb) return;
      e.preventDefault(); openSheet(el, qb.dataset.pkQuick, qb);
    });
    el.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[data-pk-add]'); if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('.pk-btn'); const label = btn.querySelector('span'); const orig = label.textContent;
      btn.classList.add('is-loading');
      try {
        await addToCart(+form.querySelector('[name=id]').value, 1);
        btn.classList.remove('is-loading'); btn.classList.add('is-added'); label.textContent = el.dataset.added || 'Added';
        setTimeout(() => { btn.classList.remove('is-added'); label.textContent = orig; }, 2200);
      } catch (err) { btn.classList.remove('is-loading'); label.textContent = err.message.slice(0, 40); setTimeout(() => { label.textContent = orig; }, 2600); }
    });
    select(0);
  }
  const boot = () => document.querySelectorAll('[data-prophecy-kit]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { const el = e.target.querySelector('[data-prophecy-kit]'); if (el) init(el); });
  document.addEventListener('shopify:block:select', (e) => { const el = e.target.closest('[data-prophecy-kit]'); if (!el) return; const t = el.querySelector(`.pk-cat[data-block="${e.detail.blockId}"]`); if (t) t.click(); });
})();
